<template>
  <div>
    <main class="main-content">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="card-title">نصاب ها</h6>
            <button class="btn btn-outline-primary" @click="refresh" v-if="changed">بارگیری مجدد</button>
            <router-link type="button" class="btn btn-outline-success" v-if="can('installers.create')" :to="{name: 'installers.create'}">ایجاد نصاب
              </router-link>
          </div>
          <div class="form-group">
           <label for="">سرچ براساس نام ، شماره ملی و موبایل نصاب انجام می شود!</label>
             <div class="input-group searchBox">
              <input type="text" class="form-control" placeholder="جستجو" @keyup="debounceInput" v-model="filters.search">
              <div class="input-group-append">
                <button class="btn btn-light" type="button">
                  <em class="ti-search"></em>
                </button>
              </div>
            </div>
            <hr>
          </div>
          <div class="d-flex justify-content-center height" v-if="data==null" >
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">در حال بارگذاری ...</span>
            </div>
          </div>
          <div class="table-responsive" v-else>
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>نام</th>
                  <th>شماره ملی</th>
                  <th>موبایل</th>
                  <th>تخصص</th>
                  <th>آدرس</th>
                  <th v-if="can('installer.projects')">پروژه</th>
                  <th>تنظیمات</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(installer , index) in data" :key="index" :class="installer.active === 1 ? '' : 'red'">
                  <td>{{index+1}}</td>
                  <td v-text="installer.name"></td>
                  <td v-text="installer.identfication"></td>
                    <td v-text="installer.mobile"></td>
                  <td>
                    <span v-for="(expert , index) in installer.expertise" :key="index">{{expert}}, </span>
                  </td>
                  <td v-text="installer.address"></td>
                  <td v-if="can('installer.projects')">
                    <router-link class="btn btn-primary"
                      :to="{
                        name:'installer.projects',
                        params: { id: installer.id}
                        }">
                        مشاهده
                    </router-link>
                  </td>
                  <td>
                    <div class="btn-group">
                      <div v-if="installer.active">
                        <div class="btn-group" role="group" aria-label="Basic example">
                          <button type="button" class="btn btn-outline-warning btn-rounded btn-uppercase" v-if="can('installers.edit')">
                            <router-link
                            :to="{
                              name:'installers.edit',
                              params: { id: installer.id}
                              }">
                              <em class="fa fa-edit m-r-5"></em> ویرایش
                            </router-link>
                          </button>
                          <button type="button" @click="deActive(installer.id)" v-if="can('installers.destroy')"
                            class="btn btn-outline-danger btn-rounded btn-uppercase">
                            <em class="fa fa-lock m-r-5"></em> غیرفعالسازی
                          </button>
                        </div>

                      </div>
                      <button v-else-if="can('installers.destroy')" type="button" @click="active(installer.id)"
                        class="btn btn-outline-success btn-rounded btn-uppercase">
                        <em class="fa fa-key m-r-5"></em> فعالسازی
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th>ردیف</th>
                  <th>نام</th>
                  <th>شماره ملی</th>
                  <th>موبایل</th>
                  <th>تخصص</th>
                  <th>آدرس</th>
                  <th v-if="can('installer.projects')">پروژه</th>
                  <th>تنظیمات</th>
                </tr>
              </tfoot>
            </table>
            <paginations :count="pagination.count" :current="pagination.currentPage" v-on:pages="page"></paginations>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination.js'
import paginations from '@/components/partials/paginations.vue'
import _ from 'lodash'
export default {
  name: 'PermissionIndex',
  mixins: [pagination],
  components: {
    paginations
  },
  data () {
    return {
      data: null,
      url: '/api/installers',
      type: 'get',
      what: null,
      changed: false,
      filters: {
        search: null
      }
    }
  },
  methods: {
    debounceInput: _.debounce(function () {
      this.search()
    }, 800),
    search () {
      this.changed = true
      this.url = '/api/installer/filter'
      this.type = 'post'
      this.what = 'filters'
      this.data = null
      this.start()
    },
    refresh () {
      this.changed = false
      for (const field in this.filters) {
        this.filters[field] = null
      }
      this.url = '/api/installers'
      this.type = 'get'
      this.what = null
      this.data = null
      this.start()
    },
    deActive (id) {
      const that = this
      this.$send.submit('delete', 'api/installers/' + id)
        .then(response => {
          const num = this.data.findIndex(x => x.id === response.id)
          this.data[num].active = 0
          that.openNotification(
            'top-center',
            'warn',
            '100%',
            'غیرفعال سازی:',
            'نصاب مورد نظر غیرفعال شد!'
          )
        })
    },
    active (id) {
      const that = this
      this.$send.submit('delete', 'api/installers/' + id)
        .then(response => {
          const num = this.data.findIndex(x => x.id === response.id)
          this.data[num].active = 1
          that.openNotification(
            'top-center',
            'success',
            '100%',
            'فعال سازی:',
            'نصاب مورد نظر فعال شد!'
          )
        })
    },
    openNotification (position = null, color, width = '100%', title, message) {
      this.$vs.notification({
        duration: 'none',
        width,
        color,
        position,
        title: title,
        text: message
      })
    }
  }
}

</script>
<style>
.red{
  color:red;
}
</style>
